'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/._react-dom@15.5.4@react-dom/index.js
// module id = 39
// module chunks = 0